<template>
    <UiContentwrapper>
        <UiExtraNarrowColumn>                            
          <slot></slot>
        </UiExtraNarrowColumn>
      </UiContentwrapper>
</template>